var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullets"},_vm._l((_vm.bullets),function(bullet,idx){return _c('div',{key:("bullet_" + idx),staticClass:"bullet",class:_vm.step === idx
          ? bullet.correct === null ? 'fill' : bullet.correct ? 'correct' : 'failed'
          : bullet.correct === null ? '' : bullet.correct ? 'correct' : 'failed'})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }